
import * as React from "react"
import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    if (type === "file") {
      return (
        <div className="relative">
          <input
            type="file"
            className={cn(
              "absolute inset-0 opacity-0 w-full h-full cursor-pointer z-10",
              className
            )}
            ref={ref}
            {...props}
          />
          <div className={cn(
            "flex h-10 w-full cursor-pointer items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 relative overflow-hidden group shadow-sm hover:shadow-md",
          )}>
            <span className="absolute inset-0 w-full h-full bg-gradient-shimmer -translate-x-full group-hover:translate-x-full transition-transform duration-1000 opacity-20"></span>
            <span className="relative z-1">Choose File {props.value ? `: ${props.value}` : ''}</span>
          </div>
        </div>
      )
    }

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus:border-primary transition-colors disabled:cursor-not-allowed disabled:opacity-50 md:text-sm shadow-sm focus:shadow-md",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
